import inView from 'in-view';
import $ from 'jquery';

const SELECTOR = '.flexible-layout, .wp-block-columns, .main > .wp-block-group, .wp-block-group__inner-container, .is-style-banner-content, .draw-highlight, .elementor-section';

function onDocumentReady() {
	inView.offset(100);

	$(SELECTOR).addClass('watching-viewport');

	inView(SELECTOR).on('enter', onLayoutEnter);
}

function onLayoutEnter(el) {
	if (el.classList.contains('in-view')) {
		return;
	}

	el.classList.add('in-view');
	$(el).trigger('in-view');
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
